import { useRef } from "react";
import {
    Trans,
    useTranslation,
} from "react-i18next";
import useAuth from "../../helper/useAuth";
import useParticleTextAnimation from "../../helper/useParticleTextAnimation";

import ParticleText from "./ParticleText";
import SpreadText from "./SpreadText";

import "./HeroSection.scss";

function HeroSection({ openModal }) {
    const { t, i18n } = useTranslation();
    const { isAuthenticated } = useAuth();

    const heroRef = useRef(null);
    const particlesCanvasRef = useRef(null);

    useParticleTextAnimation({
        heroRef,
        canvasRef: particlesCanvasRef,
        language: i18n.language,
    });

    const scrollToApplication = () => {
        if (!isAuthenticated) {
            openModal("login");
            return;
        }

        document
            .getElementById("partnership-application")
            ?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <section
            ref={heroRef}
            className="partnership-hero"
            aria-labelledby="partnership-hero-title"
        >
            <canvas
                ref={particlesCanvasRef}
                className="partnership-hero__particles"
                aria-hidden="true"
            />

            <div className="partnership-hero__inner">
                <div className="partnership-hero__copy">
                    <h1
                        id="partnership-hero-title"
                        className="partnership-hero__title"
                    >
                        <div className="partnership-hero__title-line">
                            <span className="partnership-hero__title-static">
                                <SpreadText>
                                    {t("partnership.hero.title")}
                                </SpreadText>
                            </span>

                            <span className="animated-text">
                                <Trans
                                    i18nKey="partnership.hero.animatedText"
                                    components={{
                                        brand: <ParticleText />,
                                    }}
                                />
                            </span>
                        </div>

                        <span className="partnership-hero__title-line partnership-hero__title-line--second">
                            <SpreadText>
                                {t("partnership.hero.titleSecondLine")}
                            </SpreadText>
                        </span>
                    </h1>

                    <p className="partnership-hero__description">
                        {t(
                            "partnership.hero.description"
                        )}
                    </p>
                </div>

                <div className="partnership-hero__actions">
                    <button
                        type="button"
                        className="partnership-hero__button partnership-hero__button--apply"
                        onClick={scrollToApplication}
                    >
                        {t(
                            "partnership.hero.apply"
                        )}
                    </button>


                </div>
            </div>
        </section>
    );
}

export default HeroSection;
